export const PAGE_SIZE_10 = 10
export const PAGE_SIZE_15 = 15
export const PAGE_SIZE_30 = 30
export const PAGE_SIZE_100 = 100
export const PAGE_SIZE_MAX_DEFAULT = PAGE_SIZE_30
export const PAGE_SIZE_MIN_DEFAULT = PAGE_SIZE_10

